var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { renderStackedBarCells } from '@web/components/layout/RechartsItems/StackedBarCells';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { DOC_REVIEW_CONFIG } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter, hasTeamAverageTotals } from '@web/utility/ tooltip/periodComparisonTooltip';
import { ComparisonPeriod, navigateChartPeriodBarClick, navigateToDriveAdvancedSearch } from '@web/utility/chartNavigation';
import { formatChartDayPeriodAxisLabel, getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { DriveEventActionEnum } from '@workalizer/shared';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { getInterval } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var DOC_REVIEW_SERIES_KEYS = ['approved', 'rejected'];
var docReviewTeamStripePatternId = function (dataKey) {
    return "".concat(InsightTypeEnum.docReviewCount, "_").concat(dataKey);
};
export var DocReviewCount = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var navigationScope = {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    };
    var _b = trpc.docReviewCount.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), docReviewData = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !docReviewData) {
        return _jsx(Loading, {});
    }
    var showTeamAverage = Boolean(userId) && hasTeamAverageTotals(docReviewData.totals);
    var interval = getInterval(dateFrom, dateTo);
    var legendItems = [
        __assign({ key: 'approved', currentValue: docReviewData.totals.accepted.current, prevValue: docReviewData.totals.accepted.previous.diff, diffValue: docReviewData.totals.accepted.previous }, (userId &&
            docReviewData.totals.accepted.teamAverage && {
            teamAverage: docReviewData.totals.accepted.teamAverage
        })),
        __assign({ key: 'rejected', currentValue: docReviewData.totals.rejected.current, prevValue: docReviewData.totals.rejected.previous.diff, diffValue: docReviewData.totals.rejected.previous }, (userId &&
            docReviewData.totals.rejected.teamAverage && {
            teamAverage: docReviewData.totals.rejected.teamAverage
        }))
    ];
    var docReviewSeriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter({
        approved: t('tooltip.metrics.approved'),
        rejected: t('tooltip.metrics.rejected')
    });
    var chartData = docReviewData.periods.map(function (period) { return (__assign({ period: period.period, previousPeriodLabel: period.previousPeriodLabel, previousApproved: period.prevAccepted, previousRejected: period.prevRejected, currentApproved: period.accepted, currentRejected: period.rejected }, (showTeamAverage &&
        period.teamAccepted != null &&
        period.teamRejected != null && {
        teamApproved: period.teamAccepted,
        teamRejected: period.teamRejected
    }))); });
    var _c = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: showTeamAverage ? 3 : 2
    }), barGap = _c.barGap, barSize = _c.barSize, periodXAxis = _c.periodXAxis, periodBarChartMargin = _c.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(chartData);
    var tooltipSeriesOrder = showTeamAverage
        ? [
            'previousApproved',
            'previousRejected',
            'currentApproved',
            'currentRejected',
            'teamApproved',
            'teamRejected'
        ]
        : [
            'previousApproved',
            'previousRejected',
            'currentApproved',
            'currentRejected'
        ];
    var teamStripePatterns = showTeamAverage
        ? [
            {
                patternId: docReviewTeamStripePatternId('teamApproved'),
                chartColor: DOC_REVIEW_CONFIG.approved.teamChartColor
            },
            {
                patternId: docReviewTeamStripePatternId('teamRejected'),
                chartColor: DOC_REVIEW_CONFIG.rejected.teamChartColor
            }
        ]
        : [];
    var stripeSwatchColors = showTeamAverage
        ? {
            teamApproved: DOC_REVIEW_CONFIG.approved.teamChartColor,
            teamRejected: DOC_REVIEW_CONFIG.rejected.teamChartColor
        }
        : undefined;
    var renderDocReviewTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: tooltipSeriesOrder, periodComparisonTooltip: true, seriesLabelFormatter: docReviewSeriesLabelFormatter, stripeSwatchColors: stripeSwatchColors }), chartData.length);
    var handleBarClick = function (barData, fallbackIndex, dataKey) {
        var stack = dataKey.startsWith('previous')
            ? ComparisonPeriod.Previous
            : ComparisonPeriod.Current;
        var driveSearchAction = dataKey.includes('Approved')
            ? DriveEventActionEnum.DOCUMENT_ACCEPT_SUGGESTION
            : DriveEventActionEnum.DOCUMENT_REJECT_SUGGESTION;
        navigateChartPeriodBarClick(__assign({ chartData: chartData, barData: barData, fallbackIndex: fallbackIndex, stack: stack, destination: {
                kind: 'driveAdvancedSearch',
                driveSearchAction: driveSearchAction
            } }, navigationScope));
    };
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.reviewCount'), description: t('widgetTitleDescriptions.initiativeAndOwnership.docReviewCount'), insightType: InsightTypeEnum.docReviewCount, insightsData: docReviewData, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.reviewCount'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            return [2 /*return*/, ((_a = docReviewData.periods) !== null && _a !== void 0 ? _a : []).map(function (period) {
                                    var _a, _b;
                                    var approvedLabel = t("app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.".concat(DOC_REVIEW_CONFIG.approved.translationKey));
                                    var rejectedLabel = t("app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.".concat(DOC_REVIEW_CONFIG.rejected.translationKey));
                                    return __assign((_a = {}, _a[t('filters.period')] = period.period, _a["".concat(t('export.current'), " ").concat(approvedLabel)] = period.accepted, _a["".concat(t('export.previous'), " ").concat(approvedLabel)] = period.prevAccepted, _a["".concat(t('export.current'), " ").concat(rejectedLabel)] = period.rejected, _a["".concat(t('export.previous'), " ").concat(rejectedLabel)] = period.prevRejected, _a), (showTeamAverage &&
                                        period.teamAccepted != null &&
                                        period.teamRejected != null && (_b = {},
                                        _b["".concat(t('export.teamAverage'), " ").concat(approvedLabel)] = period.teamAccepted,
                                        _b["".concat(t('export.teamAverage'), " ").concat(rejectedLabel)] = period.teamRejected,
                                        _b)));
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(docReviewData) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: DOC_REVIEW_SERIES_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx("div", __assign({ className: "flex gap-8 lg:gap-8 mb-6 p-4 ml-2 rounded-lg justify-start flex-wrap" }, { children: legendItems.map(function (_a) {
                                    var key = _a.key, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                                    return (_jsx(LegendItem, { color: DOC_REVIEW_CONFIG[key]
                                            .color, label: t("app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.".concat(DOC_REVIEW_CONFIG[key]
                                            .translationKey)), currentValue: currentValue.toString(), diffValue: diffValue, teamAverage: teamAverage, onClick: function () { return toggleSeries(key); }, onValueClick: function () {
                                            return navigateToDriveAdvancedSearch(navigationScope, {
                                                driveSearchAction: key === 'approved'
                                                    ? DriveEventActionEnum.DOCUMENT_ACCEPT_SUGGESTION
                                                    : DriveEventActionEnum.DOCUMENT_REJECT_SUGGESTION
                                            });
                                        }, isHidden: !isSeriesVisible(key) }, key));
                                }) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "period", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                                    return formatChartDayPeriodAxisLabel(value, interval, {
                                                        dateFrom: dateFrom,
                                                        dateTo: dateTo
                                                    });
                                                } })), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, allowDecimals: false }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderDocReviewTooltip }), _jsx(Bar, __assign({ dataKey: "previousApproved", fill: DOC_REVIEW_CONFIG.approved.prevChartColor, stackId: "prev", hide: !isSeriesVisible('approved'), onClick: function (barData, barIndex) {
                                                    return handleBarClick(barData, barIndex, 'previousApproved');
                                                }, style: { cursor: 'pointer' } }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: ['previousApproved', 'previousRejected'],
                                                    segmentIndex: 0,
                                                    keyPrefix: 'prev-approved'
                                                }) })), _jsx(Bar, __assign({ dataKey: "previousRejected", fill: DOC_REVIEW_CONFIG.rejected.prevChartColor, stackId: "prev", hide: !isSeriesVisible('rejected'), onClick: function (barData, barIndex) {
                                                    return handleBarClick(barData, barIndex, 'previousRejected');
                                                }, style: { cursor: 'pointer' } }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: ['previousApproved', 'previousRejected'],
                                                    segmentIndex: 1,
                                                    keyPrefix: 'prev-rejected'
                                                }) })), _jsx(Bar, __assign({ dataKey: "currentApproved", fill: DOC_REVIEW_CONFIG.approved.chartColor, stackId: "curr", hide: !isSeriesVisible('approved'), onClick: function (barData, barIndex) {
                                                    return handleBarClick(barData, barIndex, 'currentApproved');
                                                }, style: { cursor: 'pointer' } }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: ['currentApproved', 'currentRejected'],
                                                    segmentIndex: 0,
                                                    keyPrefix: 'curr-approved'
                                                }) })), _jsx(Bar, __assign({ dataKey: "currentRejected", fill: DOC_REVIEW_CONFIG.rejected.chartColor, stackId: "curr", hide: !isSeriesVisible('rejected'), onClick: function (barData, barIndex) {
                                                    return handleBarClick(barData, barIndex, 'currentRejected');
                                                }, style: { cursor: 'pointer' } }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: ['currentApproved', 'currentRejected'],
                                                    segmentIndex: 1,
                                                    keyPrefix: 'curr-rejected'
                                                }) })), showTeamAverage && (_jsxs(_Fragment, { children: [_jsx(Bar, __assign({ dataKey: "teamApproved", fill: rechartsDiagonalStripeFillUrl(docReviewTeamStripePatternId('teamApproved')), stackId: "team", hide: !isSeriesVisible('approved') }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: ['teamApproved', 'teamRejected'],
                                                            segmentIndex: 0,
                                                            keyPrefix: 'team-approved'
                                                        }) })), _jsx(Bar, __assign({ dataKey: "teamRejected", fill: rechartsDiagonalStripeFillUrl(docReviewTeamStripePatternId('teamRejected')), stackId: "team", hide: !isSeriesVisible('rejected') }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: ['teamApproved', 'teamRejected'],
                                                            segmentIndex: 1,
                                                            keyPrefix: 'team-rejected'
                                                        }) }))] })), rechartsDiagonalStripePatternDefs(teamStripePatterns)] })) })) }))] })));
                } }))] })));
};
